import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  examV3ReservationSettingsSelector,
  selectReservationOption,
} from 'slices/examV3Settings.slice';
import { fieldMappingSelector } from 'slices/field.slice';
import { reservationModesSelector } from 'slices/reservationMode.slice';
import { reservationTemplatesSelector } from 'slices/reservationTemplate.slice';
import { useAppDispatch } from 'slices/store';
import { TEInput } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
import './ReservationSettings.scss';

const ExamV3ReservationSettings = () => {
  const dispatch = useAppDispatch();
  const reservationMode = useSelector(reservationModesSelector);
  const reservationTemplate = useSelector(reservationTemplatesSelector);
  const reservationSettings = useSelector(examV3ReservationSettingsSelector);
  const fieldMapping = useSelector(fieldMappingSelector);

  const capacityReservationTemplateFields = useMemo(() => {
    const capReservation = reservationTemplate?.find(
      (template) =>
        template?.id === reservationSettings.capacityReservationTemplate
    );

    if (!capReservation) return [];

    return capReservation.fields
      .map((field) => {
        return fieldMapping?.[field];
      })
      .filter(Boolean);
  }, [reservationSettings, reservationTemplate, fieldMapping]);

  const selectHandler = (data: Record<string, number>) => {
    dispatch(selectReservationOption(data));
  };

  return (
    <Space
      size="large"
      direction="vertical"
      className="reservation-settings-list"
    >
      <TEInput.Select
        label="Reservation Mode for exam"
        className="reservation-setting-select"
        wrapperClassName="reservation-setting-wrapper"
        value={reservationSettings.examReservationMode}
        onChange={(value) => selectHandler({ examReservationMode: value })}
        allowClear
        showSearch
        options={reservationMode.map((mode) => ({
          label: mode.name,
          value: mode.id,
        }))}
      />
      <TEInput.Select
        label="Reservation template for size reservation"
        className="reservation-setting-select"
        wrapperClassName="reservation-setting-wrapper"
        value={reservationSettings.sizeReservationTemplate}
        onChange={(value) => selectHandler({ sizeReservationTemplate: value })}
        allowClear
        showSearch
        options={reservationTemplate.map((mode) => ({
          label: mode.name,
          value: mode.id,
        }))}
      />
      <TEInput.Select
        label="Reservation template for capacity reservation"
        className="reservation-setting-select"
        wrapperClassName="reservation-setting-wrapper"
        value={reservationSettings.capacityReservationTemplate}
        onChange={(value) =>
          selectHandler({ capacityReservationTemplate: value })
        }
        allowClear
        showSearch
        options={(reservationTemplate || []).map((mode) => ({
          label: mode.name,
          value: mode.id,
        }))}
      />
      <TEInput.Select
        label="Required invigilator number field"
        className="reservation-setting-select"
        wrapperClassName="reservation-setting-wrapper"
        value={reservationSettings.requiredInvigilatorNumber}
        onChange={(value) =>
          selectHandler({ requiredInvigilatorNumber: value })
        }
        allowClear
        showSearch
        options={(capacityReservationTemplateFields || []).map((mode) => ({
          label: mode.name,
          value: mode.id,
        }))}
      />
    </Space>
  );
};

export default ExamV3ReservationSettings;
